export default __webpack_public_path__ + "static/media/pizza2.146fdda2.png";